import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { QueryKeys } from "config/query-keys";
import { RequestOtpPayload } from "./dto";

export const passwordOtpRequest = async (data:RequestOtpPayload ): Promise<string> => {
  const auth = getAuth();
  
  if (!data.emailOrPhone) {
    throw new Error("Email is required to send a password reset request.");
  }

  try {
    sendPasswordResetEmail(auth, data.emailOrPhone).then(() => {
      return "Success"
    });  
    
  } catch (error) {
    console.error("Error sending password reset email:", error);
    throw error;
  }
  return "Error";
};

export const useEnumeratorPasswordOtpRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: passwordOtpRequest,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.ENUMERATOR] });
      notification.success({
        message: "Password Reset Email Sent",
        description: "A password reset email has been sent to the given email address.",
      });
    },
    onError: (error: any) => {
      notification.error({
        message: "Error",
        description: error.message || "An error occurred while sending the password reset email.",
      });
    },
  });
};